var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDContentLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.52886 9.11183H32.8396C34.1457 9.11183 35.2142 10.1803 35.2142 11.488V50.7301C35.2142 52.0361 34.1457 53.1063 32.8396 53.1063H2.52886C1.22281 53.1063 0.154297 52.0378 0.154297 50.7301V11.488C0.154297 10.182 1.22281 9.11183 2.52886 9.11183ZM11.1755 0.846191H41.4863C42.7923 0.846191 43.8609 1.9147 43.8609 3.2224V42.4645C43.8609 43.7705 42.7923 44.8407 41.4863 44.8407H37.7936V11.4899C37.7936 8.76558 35.564 6.53593 32.8396 6.53593H8.80066V3.22424C8.80066 1.91819 9.86917 0.848038 11.1769 0.848038L11.1755 0.846191ZM8.01727 19.5713C7.30573 19.5713 6.72845 18.994 6.72845 18.2825C6.72845 17.571 7.30577 16.9937 8.01727 16.9937H27.3527C28.0642 16.9937 28.6415 17.571 28.6415 18.2825C28.6415 18.994 28.0642 19.5713 27.3527 19.5713H8.01727ZM8.01727 45.2267C7.30573 45.2267 6.72845 44.6494 6.72845 43.9379C6.72845 43.2264 7.30577 42.6491 8.01727 42.6491H27.3527C28.0642 42.6491 28.6415 43.2264 28.6415 43.9379C28.6415 44.6494 28.0642 45.2267 27.3527 45.2267H8.01727ZM8.01727 36.675C7.30573 36.675 6.72845 36.0977 6.72845 35.3862C6.72845 34.6747 7.30577 34.0974 8.01727 34.0974H27.3527C28.0642 34.0974 28.6415 34.6747 28.6415 35.3862C28.6415 36.0977 28.0642 36.675 27.3527 36.675H8.01727ZM8.01727 28.1233C7.30573 28.1233 6.72845 27.546 6.72845 26.8345C6.72845 26.123 7.30577 25.5457 8.01727 25.5457H27.3527C28.0642 25.5457 28.6415 26.123 28.6415 26.8345C28.6415 27.546 28.0642 28.1233 27.3527 28.1233H8.01727Z",
    fill: "url(#paint0_linear_3_31990)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_31990",
    x1: 5.21936,
    y1: 0.846193,
    x2: 42.6736,
    y2: 42.7949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#359EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4DC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDContentLibrary);
export default __webpack_public_path__ + "static/media/d_content_library.6b9fbff949a763fca33d92d9af5cb214.svg";
export { ForwardRef as ReactComponent };